import React from "react";

export function FilterPanel({ children }) {
  return <details className="filter-panel"><summary>Фильтр</summary>{children}</details>;
}
